module.exports = __webpack_public_path__ + "img/Bad.669169fc.jpg";